import { IBidResponse } from '../../typings/IPrebid'
import type { ISlotTargeting } from '../slots/Slot'
/* eslint-disable no-var,no-console */

export type GamTargeting = { [key in keyof ISlotTargeting]: Array<string> }

export type FunctionMessages =
  | typeof renderAdSafeframe
  | typeof renderAdNonSafeframe
  | typeof renderAdAmazon

/* 
  Create our Function Message.
  The functionStr is our encoded, stringified function to execute.
  Arguments needed to execute are in the args array.
  Our typing enforces the correct arguments are given to execute the 
  specified function.
*/
export const getRenderAdFunction = (
  targeting: GamTargeting,
  isAmazon = false
): Function => {
  if (isAmazon) {
    return renderAdAmazon
  }

  return targeting.hb_safeframe && targeting.hb_safeframe[0] === '0'
    ? renderAdNonSafeframe
    : renderAdSafeframe
}

/* 
  This function must be 100% pure, meaning no external dependencies can be
  referenced. All dependencies must be injected as arguments.
 */
export function renderAdSafeframe(adObject: IBidResponse) {
  var body = window.document.body
  var ad = adObject.ad
  var url = adObject.adUrl
  var width = adObject.width
  var height = adObject.height
  if (adObject.mediaType === 'video') {
    console.log('Error trying to write ad.')
  } else if (ad) {
    var frame = document.createElement('iframe')
    frame.setAttribute('FRAMEBORDER', '0')
    frame.setAttribute('SCROLLING', 'no')
    frame.setAttribute('MARGINHEIGHT', '0')
    frame.setAttribute('MARGINWIDTH', '0')
    frame.setAttribute('TOPMARGIN', '0')
    frame.setAttribute('LEFTMARGIN', '0')
    frame.setAttribute('ALLOWTRANSPARENCY', 'true')
    frame.setAttribute('width', width.toString())
    frame.setAttribute('height', height.toString())
    body.appendChild(frame)
    if (frame.contentDocument) {
      frame.contentDocument.open()
      frame.contentDocument.write(ad)
      frame.contentDocument.close()
      // If it's an interstitial ad, we need to also resize the iframe that contains this iframe.
      // Interstitials are double-nested.
      if (
        adObject.adUnitCode === 'interstitial_mobile' ||
        adObject.adUnitCode === 'interstitial_desktop'
      ) {
        const adFrame = window.parent.document.querySelector(
          'iframe#ad_iframe'
        ) as HTMLIFrameElement
        if (adFrame) {
          adFrame.style.width = `${width}px`
          adFrame.style.height = `${height}px`
        }
      }
    }
  } else if (url) {
    body.insertAdjacentHTML(
      'beforeend',
      '<IFRAME SRC="' +
        url +
        '" FRAMEBORDER="0" SCROLLING="no" MARGINHEIGHT="0" MARGINWIDTH="0" TOPMARGIN="0" LEFTMARGIN="0" ALLOWTRANSPARENCY="true" WIDTH="' +
        width +
        '" HEIGHT="' +
        height +
        '"></IFRAME>'
    )
  }
}

export function renderAdNonSafeframe(adObject: IBidResponse) {
  var w: any = window
  for (var i = 0; i < 10; i++) {
    w = w.parent
    if (w.pbjs) {
      try {
        // @ts-ignore
        w.pbjs.renderAd(document, adObject.adId)
        break
      } catch (e) {
        continue
      }
    }
  }
}

export function renderAdAmazon(adObject: IBidResponse) {
  var amzn_win: any = window
  var amzn_c = 5
  var amzn_x = 0
  while (amzn_x < amzn_c) {
    amzn_win = amzn_win.parent
    if (amzn_win.apstag) {
      try {
        // @ts-ignore
        amzn_win.apstag.renderImp(document, adObject.ext.amzniid)
        amzn_x = amzn_c
      } catch (e) {
        /** no-op */
      }
      amzn_x++
    }
  }
}
